export enum RootCause {
    CUSTOMER_SITE = 'Customer Site',
    COMMUNICATION = 'Communication',
    HUMAN_ERROR = 'Human Error',
    INVALID_COD = 'Invalid COD',
    PACKING_DESIGN = 'Packing Design',
    PROCEDURE_INADEQUATE = 'Procedure Inadequate',
    PROCEDURE_NOT_FOLLOWED = 'Procedure not Followed',
    WEATHER_RELATED = 'Weather Related',
    SYSTEM = 'System',
    UNABLE_TO_CONFIRM = 'Unable to Confirm'
}
